export enum CHALLANGE_NAME {
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED'
}
